import webApi from "../WebApi/WebApi";

export const getSchemeMaster = async () => {
    return await webApi.get(`/MIS/impSchemeMaster`,);
}

export const getFinYear = async (lgdCode) => {
    return await webApi.get(`/MonthClose/FinYear?lgdCode=${lgdCode}`);
}

export const getSchemeBalance = async (dist, block, gp, scheme, finYear, report) => {
    return await webApi.get(`/MIS/SchemeBalance?distLgd=${dist}&blockLgd=${block}&gpLgd=${gp}&schemeId=${scheme}&finYear=${finYear}&rptType=${report}`,);
}